export enum UserWalletType {
  /** @deprecated replaced by {WALLETLESS} */
  walletless = 'walletless',
  /** @deprecated replaced by {PRIVATE_WALLET} */
  privateWallet = 'private_wallet',
  PRIVATE_WALLET = 'private_wallet',
  PASSKEY = 'passkey',
  WALLETLESS = 'walletless',
  XALIAS = 'xalias',
}
